export default [{
    text: 'Офис',
    value: 'office'
}, {
    text: 'Склад',
    value: 'warehouse'
}, {
    text: 'Торговая площадь',
    value: 'shoppingArea'
}, {
    text: 'Производство',
    value: 'industry'
}, {
    text: 'Здание',
    value: 'building'
}, {
    text: 'Помещение свободного назначения',
    value: 'freeAppointment'
}, {
    text: 'Земля',
    value: 'land'
}, {
    text: 'Гараж',
    value: 'garage'
}];
